import { IonPage, IonSpinner } from '@ionic/react';
import { useDispatch } from 'react-redux';
import { useAcknowledgeTermsOfServiceMutation } from '../api/UserApi';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { PostContentsToHTML } from '../components/PostContentsToHTML';
import { IconCheck, IconLogout } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { setRequireTermsOfService } from '../state/loginSlice';
import { siteSettingsTextReplacements } from '../util/siteSettingsTextReplacements';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI.js';
import { useHistory } from 'react-router';

export const AcceptTermsOfService: React.FC = () => {
	const [acknowledgeTermsOfService] = useAcknowledgeTermsOfServiceMutation();
	const history = useHistory();
	const { data: siteSettings } = useGetPublicInformationQuery();
	const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
	const acceptTerms = async () => {
		if (siteSettings) {
			await acknowledgeTermsOfService(siteSettings.termsOfServiceVersion);
			dispatch(setRequireTermsOfService(false));
			history.replace('/main/latest');
		}
	};

	return (
		<IonPage>
			{!siteSettings ? (
				<QuirkIonContent fullscreen={true}>
					<div className="center-align">
						<IonSpinner color="primary" />
					</div>
				</QuirkIonContent>
			) : (
				<>
					<Header
						title="logo"
						left={
							<a href={`/main/settings/logout`} className="nounderline">
								<IconButton label="Logout" icon={<IconLogout />} />
							</a>
						}
						right={
							<div>
								<IconButton
									label="Accept"
									icon={<IconCheck />}
									onClick={acceptTerms}
									testId="termsAcceptButton"
								/>
							</div>
						}
					/>
					<QuirkIonContent>
						<div className={sharedStyles.contentWrapper}>
							<div className={sharedStyles.documentHeader}>
								Please accept the Terms of Service to proceed
							</div>
							<PostContentsToHTML>
								{siteSettings &&
									siteSettingsTextReplacements(siteSettings, siteSettings.termsOfService)}
							</PostContentsToHTML>
						</div>
					</QuirkIonContent>
				</>
			)}
		</IonPage>
	);
};
